import React from 'react';
import { Link } from 'react-router-dom';
import './WithdrawalSuccess.css';

const WithdrawalSuccess: React.FC = () => {
  const withdrawalData = {
    amount: '9.9999',
    currency: 'USDT',
    usdValue: '10.00',
    method: 'Crypto Network',
    transactionId: 'TXNI9A97DJ36',
    dateTime: '11/5/2025, 2:13:42 AM',
  };

  return (
    <div className="app-container">
      <div className="mobile-frame">
        <div className="mobile-notch"></div>
        <div className="mobile-screen">
          <div className="withdrawal-success">
            <div className="withdrawal-success-content">
              <div className="withdrawal-success-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                  <circle cx="40" cy="40" r="36" fill="var(--color-success)" opacity="0.1"/>
                  <path d="M25 40L35 50L55 30" stroke="var(--color-success)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>

              <h1 className="withdrawal-success-title">Withdrawal Successful!</h1>
              <p className="withdrawal-success-subtitle">Your USDT has been sent successfully</p>

              <div className="withdrawal-success-details-card">
                <div className="withdrawal-success-amount-section">
                  <div className="withdrawal-success-amount-label">Amount Sent</div>
                  <div className="withdrawal-success-amount-value">
                    {withdrawalData.amount} {withdrawalData.currency}
                  </div>
                  <div className="withdrawal-success-amount-usd">≈ ${withdrawalData.usdValue} USD</div>
                </div>

                <div className="withdrawal-success-divider"></div>

                <div className="withdrawal-success-info-row">
                  <span className="withdrawal-success-info-label">Method</span>
                  <span className="withdrawal-success-info-value">{withdrawalData.method}</span>
                </div>

                <div className="withdrawal-success-info-row">
                  <span className="withdrawal-success-info-label">Transaction ID</span>
                  <span className="withdrawal-success-info-value withdrawal-success-info-value-small">
                    {withdrawalData.transactionId}
                  </span>
                </div>

                <div className="withdrawal-success-info-row">
                  <span className="withdrawal-success-info-label">Date & Time</span>
                  <span className="withdrawal-success-info-value">{withdrawalData.dateTime}</span>
                </div>

                <div className="withdrawal-success-info-row">
                  <span className="withdrawal-success-info-label">Status</span>
                  <span className="withdrawal-success-status-badge">Completed</span>
                </div>
              </div>

              <div className="withdrawal-success-notice">
                <span className="withdrawal-success-notice-icon">💡</span>
                <p className="withdrawal-success-notice-text">
                  Your withdrawal is being processed on the blockchain. This may take a few minutes depending on network congestion.
                </p>
              </div>

              <Link to="/history-withdrawal" className="withdrawal-success-btn-primary">
                View Transaction History
              </Link>

              <Link to="/withdraw" className="withdrawal-success-btn-secondary">
                Make Another Withdrawal
              </Link>

              <Link to="/dashboard" className="withdrawal-success-btn-tertiary">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalSuccess;